/* Emerald V3 — GA4 / dataLayer event scaffolding
 *
 * Listens for clicks on any element marked with data-emv3-event.
 * Reads supporting data-emv3-* attributes off the element AND its
 * ancestors (so a section-level data-emv3-route="foundation"
 * propagates to every CTA inside without repeating it on each).
 *
 * Pushes a single object into window.dataLayer in the standard
 * GA4 / GTM shape, then lets the click proceed naturally.
 *
 * Wire-up at the merchant end:
 * - GTM: set up a custom event trigger on the event names below,
 *   route to GA4 / Meta / Klaviyo as needed.
 * - GA4 directly via gtag: add a small bridge that mirrors
 *   dataLayer events into gtag('event', ...).
 *
 * Standard event names emitted by V3 sections:
 *   cta_click            — generic CTA on any V3 section
 *   route_select         — Foundation / Output / Daily System tile picked
 *   cluster_nav_click    — cross-link from a trust cluster page
 *   subscribe_select     — subscription CTA picked
 *
 * Standard parameters captured (when present on the element or its
 * ancestors):
 *   cta_label            — visible button text
 *   cta_position         — section identifier (e.g. "home_hero", "final_cta")
 *   route_choice         — "foundation" | "output" | "daily_system" | "shop"
 *   product_lane         — "supergreens" | "ignite" | "daily_system"
 *   sku_flavour          — "pineapple" | "mango" | "strawberry"
 *   content_group        — derived from page (homepage, pdp, system, trust, journal, etc.)
 *   target_url           — the link's resolved URL
 */
(function () {
  if (window.__emv3Events) return; window.__emv3Events = true;

  // Ensure dataLayer exists.
  window.dataLayer = window.dataLayer || [];

  // Fields read off the clicked element + walked up its ancestor chain.
  // First match wins so a per-button override beats a section-level default.
  var FIELDS = [
    'event',           // event name — required
    'cta-label',
    'cta-position',
    'route-choice',
    'product-lane',
    'sku-flavour',
    'content-group',
    'target-url'
  ];

  function readAttrs(el) {
    var data = {};
    var node = el;
    while (node && node !== document.documentElement) {
      if (node.dataset) {
        FIELDS.forEach(function (key) {
          var attr = 'emv3' + key.replace(/-./g, function (m) { return m[1].toUpperCase(); });
          // attr now e.g. "emv3CtaLabel"
          if (data[key] === undefined && node.dataset[attr] !== undefined) {
            data[key] = node.dataset[attr];
          }
        });
      }
      node = node.parentElement;
    }
    return data;
  }

  function pageContentGroup() {
    var p = window.location.pathname;
    if (p === '/' || p === '') return 'homepage';
    if (p.indexOf('/products/') === 0) return 'pdp';
    if (p.indexOf('/collections/') === 0) return 'collection';
    if (p.indexOf('/blogs/') === 0) return 'journal';
    if (p === '/cart' || p.indexOf('/cart/') === 0) return 'cart';
    if (p.indexOf('/account') === 0) return 'account';
    if (p === '/pages/the-system' || p === '/pages/daily-system') return 'system';
    if (p === '/pages/shop') return 'shop_overview';
    if (p === '/pages/quality-testing' || p === '/pages/research-led-approach' ||
        p === '/pages/academic-research' || p === '/pages/ingredients') return 'trust';
    if (p === '/pages/reviews') return 'reviews';
    return 'page';
  }

  document.addEventListener('click', function (e) {
    var target = e.target.closest('[data-emv3-event]');
    if (!target) return;
    var data = readAttrs(target);
    if (!data.event) return;

    // Resolve target URL from the closest <a>.
    var href = target.tagName === 'A' ? target.getAttribute('href') :
               (target.closest('a') ? target.closest('a').getAttribute('href') : null);

    var payload = {
      event: data.event,
      cta_label:     data['cta-label']     || (target.textContent || '').trim().slice(0, 80),
      cta_position:  data['cta-position']  || null,
      route_choice:  data['route-choice']  || null,
      product_lane:  data['product-lane']  || null,
      sku_flavour:   data['sku-flavour']   || null,
      content_group: data['content-group'] || pageContentGroup(),
      target_url:    data['target-url']    || href || null
    };

    // Strip null fields for cleaner GA4 payloads.
    Object.keys(payload).forEach(function (k) { if (payload[k] == null) delete payload[k]; });

    window.dataLayer.push(payload);
  }, { passive: true });

  // Page-view content_group seed — fired once per pageload so GTM/GA4
  // can set the content_group dimension on every event.
  window.dataLayer.push({
    event: 'emv3_page_init',
    content_group: pageContentGroup()
  });
})();
